// src/modules/app-views/_apps/applekkus/landingPages/pages/Init/components/tableColumns/statusColumn.js
// *******************************************************************************
// IMPORTS
// *******************************************************************************
import { Tag } from 'antd';
import translateX from 'utils/translateX';

// *******************************************************************************
// COLUMN FUNCTION
// *******************************************************************************
function statusColumn(buildColumnProps, options = {}) {
  const {
    key = 'status',
    title = 'status',
    dataIndex = 'status',
    width = 120,
    columnProps = { sort: true },
  } = options;

  return {
    key,
    title: translateX(title),
    dataIndex,
    width,
    align: 'center',
    ...buildColumnProps(dataIndex, columnProps),
    render: (_, r) => {
      const status = r?.status || 'draft';
      const colorMap = {
        draft: 'default',
        generating: 'processing',
        ready: 'success',
        deployed: 'blue',
        error: 'error',
      };
      return <Tag color={colorMap[status] || 'default'}>{translateX(status)}</Tag>;
    },
  };
}

export default statusColumn;
